
export * from '../../portal-workflow-instance-tracker-web/__liferay__/index.js';
